import type { PricingContent } from "../types";
import { ID_FAQS } from "./home";

export const ID_PRICING: PricingContent = {
  seoTitle: "Harga Crayo | Paket untuk Setiap Kreator",
  seoDescription:
    "Harga simpel dan transparan untuk video pendek AI. Kredit workflow, voiceover AI, gambar AI, penyimpanan, dan pelacakan views di semua paket.",
  name: "Harga Crayo",
  crumb: "Harga",
  h1: "Harga",
  subheading: "Semua paket mencakup seluruh tool Crayo. Pilih sesuai seberapa banyak kamu bikin konten.",
  faqs: [
    ...ID_FAQS,
    {
      question: "Bagaimana Crayo dibandingkan Opus Clip, CapCut, dan Submagic?",
      answer:
        "Crayo mengenakan satu kredit workflow per video jadi dan menyertakan semua tool di semua paket. Opus Clip menghitung per menit video sumber yang diupload, CapCut tidak punya halaman harga publik, dan Submagic membatasi kredit, jumlah video, dan menit per video sekaligus. Hub perbandingan menampilkan harga dan fitur bertanggal lengkap dengan sumbernya untuk masing-masing.",
      link: { href: "/compare", label: "Lihat semua perbandingan" },
    },
  ],
};
